import { useState, ChangeEvent } from 'react';
import styles from './PolicySearchBar.module.css';

interface PolicySearchBarProps {
	onSearch?: (query: string) => void;
	placeholder?: string;
}

export const PolicySearchBar = ({
	onSearch,
	placeholder = 'Buscar política...',
}: PolicySearchBarProps) => {
	const [query, setQuery] = useState('');

	const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setQuery(value);
		onSearch?.(value);
	};

	return (
		<div className={styles.searchBar}>
			<svg
				className={styles.searchIcon}
				width="20"
				height="20"
				viewBox="0 0 20 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
				<path
					d="M19 19L14.65 14.65"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
			<input
				type="text"
				value={query}
				onChange={handleChange}
				placeholder={placeholder}
				className={styles.searchInput}
			/>
		</div>
	);
};
